exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody,\n#app,\n.comments-app {\n  height: 100%; }\n", ""]);

// exports
